class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('input', () => FacetFiltersForm.updateMobileFilterButtons());

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Facet fetch failed: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        console.error(error);
        FacetFiltersForm.clearLoadingState();
      });
  }

  static clearLoadingState() {
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    const collection = document.getElementById('ProductGridContainer').querySelector('.collection');
    if (collection) collection.classList.remove('loading');

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainer) countContainer.classList.remove('loading');
    if (countContainerDesktop) countContainerDesktop.classList.remove('loading');

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    document.dispatchEvent(new CustomEvent('facets:product-grid-updated'));
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHTML.getElementById('ProductCount');
    if (!sourceCount) return;

    const count = sourceCount.innerHTML;
    const productCount = sourceCount.dataset.productsCount || '';
    const allProductCount = sourceCount.dataset.allProductsCount || '';
    const activeFilterCount = parseInt(sourceCount.dataset.activeFilters || '0', 10);
    const filteredCount = productCount || (count.match(/\d+/) || [''])[0];
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const headingCount = document.getElementById('ProductHeadingCount');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    if (headingCount) {
      const unfilteredCount = headingCount.dataset.unfiltered || allProductCount || filteredCount || '';
      const filteredValue = String(filteredCount || unfilteredCount);
      headingCount.textContent = filteredValue;
    }

    FacetFiltersForm.togglePlpBanners(activeFilterCount === 0);

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static togglePlpBanners(show) {
    const banners = document.querySelectorAll('.plp-banner');
    if (!banners.length) return;

    banners.forEach((banner) => {
      banner.classList.toggle('plp-banner--hidden', !show);
      banner.hidden = !show;
      banner.style.display = show ? '' : 'none';
      const media = banner.querySelector('.plp-banner__media');
      if (media) {
        media.hidden = !show;
        media.style.display = show ? '' : 'none';
      }
    });

    if (show) {
      const plpBannerGrid = document.querySelector('plp-banner-grid');
      if (plpBannerGrid && typeof plpBannerGrid.placeBanners === 'function') {
        plpBannerGrid.placeBanners();
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        const wasOpen = currentElement.classList.contains('is-open');
        currentElement.innerHTML = elementToRender.innerHTML;

        // The freshly-rendered markup doesn't know this accordion was open, so its
        // panel comes back collapsed (height: 0) even though `is-open` (and thus the
        // chevron) is preserved on the untouched outer element. Re-sync the panel so
        // it doesn't silently collapse whenever a different filter is applied.
        if (wasOpen) {
          const toggle = currentElement.querySelector('.mobile-facets__summary-accordion');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
          const panel = currentElement.querySelector('.mobile-facets__accordion-panel');
          if (panel) panel.style.height = 'auto';
        }
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__accordion')
          ? `.mobile-facets__summary-accordion`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
      '.mobile-facets__apply-label',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();

    FacetFiltersForm.updateMobileFilterButtons();
  }

 static updateMobileFilterButtons() {
  const form = document.getElementById('FacetFiltersFormMobile');
  if (!form) return;

  const hasSelection =
    form.querySelectorAll(
      'input[type="checkbox"]:checked, input[type="radio"]:checked'
    ).length > 0;

  const clearBtn = form.querySelector('.mobile-facets__clear');
  const clearWrapper = form.querySelector('.mobile-facets__clear-wrapper');
  const applyBtn = form.querySelector('.mobile-facets__apply');

  if (clearBtn) {
    clearBtn.classList.toggle('disabled', !hasSelection);
    clearBtn.style.pointerEvents = hasSelection ? 'auto' : 'none';
  }

  if (clearWrapper) {
    clearWrapper.classList.toggle('mobile-facets__clear-wrapper--active', hasSelection);
  }

  if (applyBtn) {
    applyBtn.classList.toggle('disabled', !hasSelection);
    applyBtn.classList.toggle('mobile-facets__apply--active', hasSelection);
    applyBtn.style.pointerEvents = hasSelection ? 'auto' : 'none';
  }
}

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    FacetFiltersForm.updateMobileFilterButtons();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener('DOMContentLoaded', () => {
  FacetFiltersForm.updateMobileFilterButtons();

  const initialCount = document.getElementById('ProductCount');
  if (initialCount) {
    const activeFilterCount = parseInt(initialCount.dataset.activeFilters || '0', 10);
    FacetFiltersForm.togglePlpBanners(activeFilterCount === 0);
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);

    if (this.querySelector('a.mobile-facets__clear-all')) {
      closeFacetsDrawer();

      const mobileForm = document.getElementById('FacetFiltersFormMobile');
      if (mobileForm) {
        const clearBtn = mobileForm.querySelector('.mobile-facets__clear');
        const clearWrapper = mobileForm.querySelector('.mobile-facets__clear-wrapper');
        const applyBtn = mobileForm.querySelector('.mobile-facets__apply');

        if (clearBtn) {
          clearBtn.classList.add('disabled');
          clearBtn.style.pointerEvents = 'none';
        }
        if (clearWrapper) clearWrapper.classList.remove('mobile-facets__clear-wrapper--active');
        if (applyBtn) {
          applyBtn.classList.add('disabled');
          applyBtn.classList.remove('mobile-facets__apply--active');
          applyBtn.style.pointerEvents = 'none';
        }
      }
    }
  }
}

customElements.define('facet-remove', FacetRemove);

function closeFacetsDrawer() {
  const openDrawer = document.querySelector('.mobile-facets__disclosure[open]');
  if (openDrawer) openDrawer.querySelector('summary')?.click();
}

function getFacetsDrawerFilters() {
  return document.getElementById('FacetsWrapperMobile');
}

function setAccordionOpen(accordion, open) {
  accordion.classList.toggle('is-open', open);
  const toggle = accordion.querySelector('.mobile-facets__summary-accordion');
  if (toggle) toggle.setAttribute('aria-expanded', String(open));
  animateAccordionPanel(accordion.querySelector('.mobile-facets__accordion-panel'), open);
}

// Panels are collapsed via a `height` transition rather than display:none/block so
// the open/close can animate smoothly; the inline height is cleared once the panel
// is fully open so its content can still reflow (e.g. on viewport resize).
function animateAccordionPanel(panel, open) {
  if (!panel) return;

  if (panel._onAccordionTransitionEnd) {
    panel.removeEventListener('transitionend', panel._onAccordionTransitionEnd);
    panel._onAccordionTransitionEnd = null;
  }

  if (open) {
    panel.style.height = `${panel.scrollHeight}px`;
    const onTransitionEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', onTransitionEnd);
      panel._onAccordionTransitionEnd = null;
    };
    panel._onAccordionTransitionEnd = onTransitionEnd;
    panel.addEventListener('transitionend', onTransitionEnd);
  } else {
    if (panel.style.height === 'auto') panel.style.height = `${panel.scrollHeight}px`;
    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });
  }
}

// In-memory (not sessionStorage) on purpose: it should remember the last manually-opened
// category (even one with no active pill, e.g. still browsing) across close/reopen within
// the same page view, but always reset on a fresh page load/reload. Categories with an
// active filter always reopen regardless of this value.
let lastOpenedFacetsFilterId = null;

function restoreOpenFacetsFilter() {
  const root = getFacetsDrawerFilters();
  if (!root) return;

  // Every category with an actively applied filter should open by default (facets.liquid
  // only marks a pill `active` once the user has explicitly chosen it, sort included, so
  // there's no default-selection noise to exclude here).
  const targets = new Set(
    Array.from(root.querySelectorAll('.js-filter')).filter((accordion) =>
      accordion.querySelector('.mobile-facets__pill.active')
    )
  );

  if (lastOpenedFacetsFilterId) {
    const lastOpened = root.querySelector(`#${CSS.escape(lastOpenedFacetsFilterId)}`);
    if (lastOpened) targets.add(lastOpened);
  }

  targets.forEach((target) => setAccordionOpen(target, true));
}

// Accordion filter categories are plain buttons + panels (not <details>), so each
// one opens/closes independently on click without the drill-down/back-button
// behavior menu-drawer's generic <details> handling assumes.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.mobile-facets__summary-accordion');
  if (!toggle) return;

  const accordion = toggle.closest('.js-filter');
  if (!accordion || !accordion.closest('#FacetsWrapperMobile')) return;

  const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
  setAccordionOpen(accordion, willOpen);
  if (willOpen) {
    lastOpenedFacetsFilterId = accordion.id;
  } else if (lastOpenedFacetsFilterId === accordion.id) {
    lastOpenedFacetsFilterId = null;
  }
});

document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (
      details instanceof HTMLDetailsElement &&
      details.classList.contains('mobile-facets__disclosure') &&
      details.hasAttribute('open')
    ) {
      restoreOpenFacetsFilter();
    }
  },
  true
);

// Fallback: close the facets drawer on any click outside its panel. The CSS-only
// overlay (summary::before) is unreliable here because other stacked/sticky
// elements on the page can intercept the click before it reaches the summary.
document.addEventListener(
  'click',
  (event) => {
    const openDrawer = document.querySelector('.mobile-facets__disclosure[open]');
    if (!openDrawer) return;

    const panel = openDrawer.querySelector('.mobile-facets__inner');
    const summary = openDrawer.querySelector('summary');
    if (panel?.contains(event.target) || summary?.contains(event.target)) return;

    summary?.click();
  },
  true
);

// The desktop facet dropdown (.facets__disclosure) and accordion sidebar
// (.facets__disclosure-vertical) only animate opening (`animateMenuOpen` in
// base.css); native <details> closes instantly. Play the same motion in
// reverse before removing `open` so closing matches opening.
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.facets__disclosure > summary, .facets__disclosure-vertical > summary');
  if (!summary) return;

  const details = summary.parentElement;
  if (!details.hasAttribute('open')) return;

  const panel = details.querySelector(':scope > .facets__display, :scope > .facets__display-vertical');
  if (!panel) return;

  event.preventDefault();

  // Duration must match --duration-default (base.css) used by the opening animation.
  const closing = panel.animate(
    [
      { opacity: 1, transform: 'translateY(0)' },
      { opacity: 0, transform: 'translateY(-1.5rem)' },
    ],
    { duration: 200, easing: 'ease' }
  );

  closing.finished
    .catch(() => {})
    .then(() => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', false);
    });
});

// Close the facets drawer whenever the header search is used (predictive search
// input focused or its results start showing), since it's not reliably reachable
// through the details-modal open() hook (the desktop search markup has no
// <details>/<summary> at all).
document.addEventListener(
  'focusin',
  (event) => {
    if (!event.target.matches('input[type="search"]')) return;
    closeFacetsDrawer();
  },
  true
);
document.querySelectorAll('.mobile-facets__accordion--sort .mobile-facets__pill-text').forEach((el) => {
  if (el.textContent.trim() === 'Best selling') {
    el.textContent = 'Best Selling';
  }
});